import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import PropTypes from "prop-types";
const IpContext = createContext();

export const useCategory = () => useContext(IpContext);

export const IpProvider = ({ children }) => {
    const [category, setCategory] = useState('patent');

    const switchCategory = useCallback((tab) => {
        setCategory(tab);
    }, []);

    const value = useMemo(
        () => ({
        category,
        switchCategory,
        }),
        [category, switchCategory]
    );

    return (
        <IpContext.Provider value={value}>
            {children}
        </IpContext.Provider>
    );
};

IpProvider.propTypes = {
    children: PropTypes.node,
};


